<template lang="pug">
  div.computerDialog
    KmDialog(
      :visible.sync="visible"
      :overflow="true"
      :showClose="false"
      class="cp_dialog"
    )
      div(slot="body")
        i.iconfont.close(@click="handleConfirm") &#xe60a;
        div.computer_body
          p 未结束的「机房练习」仅支持在学校机房里进行练习哦~
        div.computer_tips 
          span 注：已结束的机房练习支持复习
      div(slot="footer" class="computer_foot")
        button(@click="handleConfirm") 知道了

</template>

<script>
import { KmDialog } from '@/ui'
export default {
  components: { KmDialog },
  name: 'computer',
  props: ['visible', 'onhandleConfirm'],
  data() {
    return {}
  },
  methods: {
    handleConfirm() {
      this.onhandleConfirm()
    }
  }
}
</script>

<style lang="less">
.cp_dialog {
  .content {
    min-height: 0 !important;
    height: 270px !important;
  }
}
.computer_body {
  p {
    width: 320px;
    font-size: 16px;
    color: #666;
  }
}
.computer_tips {
  margin-top: 20px;
  span {
    font-size: 12px;
    color: #999;
  }
}
.computer_foot {
  text-align: center;
  button {
    width: 120px;
    height: 40px;
    border: 1px solid #24cc7c;
    border-radius: 20px;
    background: #24cc7c;
    color: #fff;
    margin-left: 30px;
    font-size: 16px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/UIO/computerRoom.vue